import { useContext } from "react";
import UserContext from "../contexts/user-context";

const useCurrentUser = () => {
  const context = useContext(UserContext);

  if (context === null) {
    throw new Error("useCurrentUser must be used within a UserContextProvider");
  }

  const { user, setUser } = context;
  return { user, setUser };
};

export { useCurrentUser };
